/* =====================================================
   DIGI HEADER – Drawer JS (Menu + Search)
   Controla abertura, fechamento e scroll lock
   ===================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const body = document.body;

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    body.classList.add('digi-header--locked');
  };

const closeDrawer = (drawer) => {
  if (!drawer) return;

  drawer.classList.remove('is-open');

  setTimeout(() => {
    drawer.hidden = true;
  }, 300);

  /* RESET VIEW */
  const rootView = drawer.querySelector('[data-menu-view="root"]');
  if (rootView) {
    drawer
      .querySelectorAll('.digi-menu-view')
      .forEach(v => v.classList.remove('is-active'));

    rootView.classList.add('is-active');
  }

  body.classList.remove('digi-header--locked');
};


  /* MENU */
  const menuOpen = document.querySelector('[data-menu-open]');
  const menuDrawer = document.querySelector('[data-digi-menu-drawer]');

  if (menuOpen && menuDrawer) {
    menuOpen.addEventListener('click', () => openDrawer(menuDrawer));
  }

  /* SEARCH */
  const searchOpens = document.querySelectorAll('[data-search-open]');
  const searchDrawer = document.querySelector('[data-search-drawer]');

  if (searchOpens.length && searchDrawer) {
    searchOpens.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer(searchDrawer);
      });
    });
  }

  /* =====================
     MENU DRAWER – ACCORDION
     ===================== */

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-submenu-toggle]');
  if (!toggle) return;

  const item = toggle.closest('.digi-menu-drawer__item');
  const submenu = item?.querySelector('.digi-menu-drawer__submenu');

  if (!submenu) return;

  const isOpen = !submenu.hasAttribute('hidden');
  submenu.toggleAttribute('hidden', isOpen);
  toggle.textContent = isOpen ? '›' : '⌄';
});


/* =====================
   MENU DRAWER – STACK NAVIGATION
   ===================== */

document.addEventListener('click', (e) => {

  /* Abrir nova view */
  const openBtn = e.target.closest('[data-open-view]');
  if (openBtn) {
    const target = openBtn.dataset.openView;
    const drawer = openBtn.closest('.digi-header-drawer');
    const view = drawer?.querySelector(`[data-menu-view="${target}"]`);
    if (!view) return;

    document
      .querySelectorAll('.digi-menu-view')
      .forEach(v => v.classList.remove('is-active'));

    view.classList.add('is-active');
  }

  /* Voltar para root */
  const backBtn = e.target.closest('[data-back]');
  if (backBtn) {
    const drawer = backBtn.closest('.digi-header-drawer');

    drawer
      ?.querySelectorAll('.digi-menu-view')
      .forEach(v => v.classList.remove('is-active'));

    const root = drawer?.querySelector('[data-menu-view="root"]');
    if (root) root.classList.add('is-active');
  }

});


  /* FECHAR (overlay ou botão) */
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-menu-close], [data-search-close]')) {
      const drawer = e.target.closest('.digi-header-drawer');
      closeDrawer(drawer);
    }

    if (e.target.classList.contains('digi-header-drawer__overlay')) {
      closeDrawer(e.target.closest('.digi-header-drawer'));
    }
  });

  /* ESC fecha tudo */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('.digi-header-drawer.is-open')
        .forEach(closeDrawer);
    }
  });

/* =====================
   DESKTOP SEARCH — lupa submete o input correto
   ===================== */

document.addEventListener('click', (e) => {
  const submitBtn = e.target.closest('[data-digi-search-submit]');
  if (!submitBtn) return;

  // procura o form MAIS PRÓXIMO dentro do header
  const header = submitBtn.closest('.header-bold');
  if (!header) return;

  const form = header.querySelector('.header-area--actions [data-digi-search-form]');
  const input = form?.querySelector('[data-digi-search-input]');

  if (!form || !input) return;

  const q = input.value.trim();
  if (!q) {
    input.focus();
    return;
  }

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
  } else {
    form.submit();
  }
});

/* =====================================================
   PREDICTIVE SEARCH — DESKTOP
   ===================================================== */

document.querySelectorAll('[data-predictive-search]').forEach((wrapper) => {

  const input = wrapper.querySelector('[data-digi-search-input]');
  const results = wrapper.querySelector('[data-predictive-results]');
  const resultsContainer = wrapper.querySelector('.digi-predictive-search__results');

  if (!input || !results || !resultsContainer) return;

  let debounce;

  input.addEventListener('input', () => {

    const query = input.value.trim();

    clearTimeout(debounce);

    if (query.length < 2) {

      results.classList.remove('is-active');
      resultsContainer.innerHTML = '';

      return;
    }

    debounce = setTimeout(async () => {

      try {

        const response = await fetch(
          `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&section_id=digi-predictive-search`
        );

        const htmlText = await response.text();

        const parser = document.createElement('div');
        parser.innerHTML = htmlText;

        const products = parser.querySelectorAll('[data-search-product]');

        let markup = '';

        products.forEach((product) => {

          const url = product.dataset.url || '#';
          const title = product.dataset.title || '';
          const image = product.dataset.image || '';
          const price = product.dataset.price || '';
          const compare = product.dataset.compare || '';

          markup += `
            <a
              href="${url}"
              class="digi-predictive-search__item"
            >

              <div class="digi-predictive-search__thumb">
                <img src="${image}" alt="${title}">
              </div>

              <div class="digi-predictive-search__content">

                <span class="digi-predictive-search__title">
                  ${title}
                </span>

                <div class="digi-predictive-search__prices">

                  ${
                    compare
                      ? `<span class="digi-predictive-search__compare">${compare}</span>`
                      : ''
                  }

                  <span class="digi-predictive-search__price">
                    ${price}
                  </span>

                </div>

              </div>

            </a>
          `;
        });

        markup += `
          <a
            href="/search?q=${encodeURIComponent(query)}"
            class="digi-predictive-search__footer"
          >
            <span>Pesquisar "${query}"</span>
            <span>→</span>
          </a>
        `;

        resultsContainer.innerHTML = markup;

        results.classList.add('is-active');

      } catch (error) {

        console.error(
          'Predictive Search Error:',
          error
        );

      }

    }, 250);

  });

  document.addEventListener('click', (event) => {

    if (!wrapper.contains(event.target)) {
      results.classList.remove('is-active');
    }

  });

});
  
});

